// @core/api/endpoints/attachment/complete_multipart_upload.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AttachmentResponse,
  CompleteMultipartUploadRequest,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Complete multipart upload
 * Finalizes a multipart upload by combining all uploaded parts into a single file. Triggers async processing after completion. All parts must be uploaded successfully before calling this.
 */
export async function CompleteMultipartUpload(
  data: CompleteMultipartUploadRequest,
  options?: RequestOptions
): Promise<AttachmentResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/attachments/multipart/complete`;
  const requestOptions = options;
  return client.post<AttachmentResponse>(requestPath, data, requestOptions);
}
